import * as yup from 'yup';
import { isValidPhoneNumber } from 'libphonenumber-js';
export const create_account_schema = {
  phoneNumber: '',
  applicantType: '',
  companyType: '',
  terms_and_conditions: false,
};

export const create_account_validation_schema = yup.object().shape({
  phoneNumber: yup
  .string()
  .required('phone_number_required')
  .test(
    'is-valid-phone',
    'phone_number_invalid',
    (value) => {
      if (!value) return false;
      return isValidPhoneNumber(value);
    }
  )
});
